import z from "zod";

const translationPath =
  "page.4uBus.integrationRule.integrationRuleField.errors.";

const selectSchema = z.object({
  id: z.string(),
  name: z.string(),
  code: z.string().optional(),
});

export const integrationRuleFieldSchema = z
  .object({
    id: z.string().optional(),
    automationField: selectSchema.nullish(),
    individualExternalId: z.string().max(500).nullish(),
    softwares: z.array(selectSchema).nullish(),
  })
  .superRefine((val, ctx) => {
    if (!val.automationField) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: translationPath + "automation_field",
        path: ["automationField"],
      });
    }
  });

export type TIntegrationRuleFieldForm = z.infer<
  typeof integrationRuleFieldSchema
>;
